module.exports = {
    bindings: {
        note: '<'
    },
    templateUrl: 'texts/components/annotation.html'
};